import type { FunctionComponent } from "react";

import { HeaderBottom } from "scmp-app/components/header/header-bottom";

import { ContentContainer, StyledMorningStudioLogo, SubheaderContainer } from "./styles";

type Props = {
  className?: string;
};

export const MorningStudioMobileSubheader: FunctionComponent<Props> = ({ className }) => (
  <HeaderBottom>
    <SubheaderContainer className={className}>
      <ContentContainer>
        <StyledMorningStudioLogo />
      </ContentContainer>
    </SubheaderContainer>
  </HeaderBottom>
);
MorningStudioMobileSubheader.displayName = "MorningStudioMobileSubheader";
